export class Region {
    constructor(
        public gid?: Number,
        public id?: string,
        public nomReg?: string,
        public inseeReg?: string,
        public version?: string
    ) {}
}